import { CdkScrollable } from "@angular/cdk/scrolling";
import { Component, OnInit, inject } from "@angular/core";
import { MatButton } from "@angular/material/button";
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef } from "@angular/material/dialog";
import { LayoutAlignDirective, LayoutDirective } from "@ngbracket/ngx-layout/flex";
import { IAttachment, ITcmModel } from "@tylertech/tyler-api-types";
import { AttachmentViewerComponent } from "../../components/attachmentViewer/attachmentViewer.component";
import { TcmViewerComponent } from "../../components/tcmViewer/tcmViewer.component";
import { DocumentService } from "../documentService.g";
import { BusyIndicatorComponent } from "@tylertech/common-components-module";

export interface AttachmentsDialogData
{
    readonly attachments: Array<IAttachment>;
    readonly docType: string;
    readonly entityId: string;
    readonly entityType: string;
    readonly isAdd: boolean;
    readonly readOnly: boolean;
    readonly tcmEntity: ITcmModel;
}

@Component({
    selector: "attachments-dialog",
    templateUrl: "./attachmentDialog.tmpl.html",
    imports: [
        AttachmentViewerComponent,
        BusyIndicatorComponent,
        CdkScrollable,
        LayoutAlignDirective,
        LayoutDirective,
        MatButton,
        MatDialogActions,
        MatDialogContent,
        TcmViewerComponent,
    ]
})
export class AttachmentDialogComponent
    implements OnInit
{
    private readonly dialogRef = inject<MatDialogRef<AttachmentDialogComponent>>(MatDialogRef);
    private readonly data = inject<AttachmentsDialogData>(MAT_DIALOG_DATA);
    private readonly $documentApiService = inject(DocumentService);

    hasTcm: boolean;

    isLoaded: boolean = false;
    protected promise: Promise<void>;

    get entityId(): string { return this.data.entityId; }
    get entityType(): string { return this.data.entityType; }
    get isAdd(): boolean { return this.data.isAdd; }
    get tcmEntity(): ITcmModel { return this.data.tcmEntity; }
    get attachments(): Array<IAttachment> { return this.data.attachments; }
    get readOnly(): boolean { return this.data.readOnly; }
    get docType(): string { return this.data.docType; }

    ngOnInit(): void
    {
        this.promise = this.$documentApiService.HasTcm()
            .then(executionResult =>
            {
                this.hasTcm = executionResult.Result;
            })
            .finally(() =>
            {
                this.isLoaded = true;
                this.promise = undefined;
            });
    }

    close(): void
    {
        this.dialogRef.close();
    }
}
